import React from "react"; 
import EntrataStyles from "./Entrata.styles";

const EntrataInstruction = () => {
    return(
        <div style={EntrataStyles.container}>
            <div style={EntrataStyles.instructionCard}>
                <strong style={EntrataStyles.strong}>Entrata.com Instructions : </strong>
                <ul style={EntrataStyles.ul}>
                    <li style={EntrataStyles.li}>In order to import your data from Entrata to Tax1099.com, please start the process from your Entrata account. Here are some things to know before getting started:</li>
                    <li style={EntrataStyles.li}><span style={EntrataStyles.bullet}>•</span>1 - An administrator in your Entrata account needs to add the app to your Entrata account.</li>
                    <li style={EntrataStyles.li}><span style={EntrataStyles.bullet}>•</span>2 - An administrator needs to add the properties you want to send 1099s to Tax1099 to the app in Entrata.</li>
                    <li style={EntrataStyles.li}><span style={EntrataStyles.bullet}>•</span>3 - If you don't have access to the app in Entrata, your Entrata administrator can give you the right permissions.</li>
                    <li style={EntrataStyles.li}><span style={EntrataStyles.bullet}>•</span>4 - Once you have the right permissions, you will be able to sync your 1099 data using the app.</li>
                    <li style={EntrataStyles.li}>When using the app, you will remain in Entrata and see Tax1099 there. If you encounter any issues logging into Tax1099 from within Entrata, please contact us at support@tax1099.com.</li>
                </ul>
            </div>
        </div>
    );
};
export default EntrataInstruction